import axiosInstance from "auth/FetchInterceptor";
import {
  EMAIL_TEMPLATE_SEARCH_GRID,
  EMAIL_TEMPLATE_DETAIL,
  EMAIL_TEMPLATE_CREATE,
  EMAIL_TEMPLATE_UPDATE,
  EMAIL_TEMPLATE_DELETE,
} from "constants/ApiConstant";

const EmailTemplateService = {};

EmailTemplateService.getEmailTemplate = function (data) {
  return axiosInstance.post(EMAIL_TEMPLATE_SEARCH_GRID, data);
};

EmailTemplateService.getEmailTemplateDetail = function (id) {
  return axiosInstance.get(`${EMAIL_TEMPLATE_DETAIL}/${id}`);
};

EmailTemplateService.createEmailTemplate = function (data) {
  return axiosInstance.post(EMAIL_TEMPLATE_CREATE, data);
};

EmailTemplateService.updateEmailTemplate = function (data) {
  return axiosInstance.post(EMAIL_TEMPLATE_UPDATE, data);
};

EmailTemplateService.delEmailTemplate = function (id) {
  return axiosInstance.delete(`${EMAIL_TEMPLATE_DELETE}/${id}`);
};

export default EmailTemplateService;